import { logAction, useRelodeReducer, useSnackMiddleware } from "@relode/core";
import * as React from "react";

import {
    ClientMarketResearchActions,
    useClientMarketResearchActions,
} from "./clientMarketResearchActions";
import { clientMarketResearchReducer } from "./clientMarketResearchReducer";
import { useClientMarketResearchSearchHandlers } from "./clientMarketResearchSearchHandlers";
import {
    ClientMarketResearchState,
    defaultClientMarketResearchState,
} from "./clientMarketResearchState";

export type ClientMarketResearchContextType = [
    ClientMarketResearchState,
    ClientMarketResearchActions
];

export const ClientMarketResearchContext =
    React.createContext<ClientMarketResearchContextType>(undefined);

export const ClientMarketResearchProvider = (props: {
    children: React.ReactNode;
}) => {
    const [state, dispatch] = useRelodeReducer(
        clientMarketResearchReducer,
        defaultClientMarketResearchState,
        [useSnackMiddleware(), logAction]
    );

    const actions = useClientMarketResearchActions(state, dispatch);
    useClientMarketResearchSearchHandlers(state, actions);

    const value = React.useMemo(
        () => [state, actions],
        [actions, state]
    ) as ClientMarketResearchContextType;

    return <ClientMarketResearchContext.Provider value={value} {...props} />;
};

export const useClientMarketResearchContext = () => {
    const context = React.useContext(ClientMarketResearchContext);
    if (!context) {
        throw new Error(
            "useClientMarketResearchContext must be used within an appropriate provider"
        );
    }
    return context;
};
